import { Injectable } from '@angular/core';
import { getAnalytics, logEvent } from '@angular/fire/analytics';

import { Notification } from '@models/notification';
import { DataService } from './data.service';
import { Announcement } from '../../../../../core/types/apiv3';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(private dataService: DataService) {}

  public trackEvent(eventName: string, eventParams: {}): void {
    logEvent(getAnalytics(), eventName, {
      ...eventParams,
      property_id: this.dataService.activeProperty
        ? this.dataService.activeProperty.id
        : null,
      property_name: this.dataService.activeProperty
        ? this.dataService.activeProperty.name
        : null,
    });
  }

  /**
   * Track something to do with an Event in the app. Standardizes what Event data to send with related custom events.
   * Slightly confusing because in Analytics tracking anything specifically is a "custom_event".
   * This refers to tracking GiGi Events.
   * @param interactionName
   * @param event
   */
  public trackEventInteraction(
    interactionName: string,
    event: Announcement,
  ): void {
    this.trackEvent(interactionName, {
      event_id: event.id,
      event_name: event.title,
      event_category: event.category.name,
      event_subcategory: event.subcategory.name,
      event_is_special: event.style.name === 'Special Event',
      event_is_mobile: event.room?.shortName === 'APP',
    });
  }

  /**
   * Track something to do with an Alert/Notification throughout the app.
   */
  public trackAlertInteraction(
    interactionName: string,
    notification: Notification,
  ): void {
    this.trackEvent(interactionName, {
      alert_id: notification.id,
      alert_title: notification.title,
      alert_more_info_url: notification.moreInfoUrl,
    });
  }
}
